import { customRef } from 'vue'
import { createI18n } from 'vue-i18n'

// 导入语言包
import zh from './locales/zh.json'
import en from './locales/en.json'

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('locale') || 'zh', // 默认语言
  fallbackLocale: 'en', // 备用语言
  messages: {
    zh: zh,
    en: en,
  },
})

export default i18n
